import { View, ViewModel } from "binder";
import { getAsBoolean } from "../../../utilities";
import { ColumnFilter } from "../columnFilter";
import { BooleanFilterView } from "./booleanFilter-view"
import { translate } from "src/common/utilities";

export class BooleanFilterViewModel extends ColumnFilter {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.text = translate("booleanFilter-viewModel.amount", {});
        this.needsReverse = false;
    }
    GetDefaultView(): View<ViewModel> {
        return new BooleanFilterView();
    }
    public getTypeId(): string {
        return "VM-2EE4CD0F-CD2F-4689-A0CD-1074C7ECC535"
    }

    public set value(v: boolean) { this._value = getAsBoolean(v); } public get value(): boolean { return this._value; } private _value: boolean;
    public set text(v: string) { this._text = v; } public get text(): string { return this._text; } private _text: string;
    public set needsReverse(v: boolean) { this._needsReverse = getAsBoolean(v); } public get needsReverse(): boolean { return this._needsReverse; } private _needsReverse: boolean;
    public set reverseText(v: string) { this._reverseText = v; } public get reverseText(): string { return this._reverseText; } private _reverseText: string;
}
